import React, { useState, useEffect } from "react";
import Select from 'react-select';

const AlumnoForm = ({ onSubmit, initialData, usuarios = [], grados = [],resetForm }) => {
    const [formData, setFormData] = useState({
        usuario_id: "",
        grado_id: "",
        ciclo:""
    });

    const limpiarSelectores = () => {

        setFormData({
            usuario_id: "",
            grado_id: "",
            ciclo:""
        });
    };

    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        }
        else if (resetForm) {
            limpiarSelectores();
        }
    }, [initialData,resetForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const opcionesUsuarios = [
        { value: "", label: "Seleccione un usuario" }, // Opción vacía
        ...usuarios.map(usuario => ({
            value: usuario.usuario_id,
            label: usuario.nombre
        }))
    ];

    const opcionesGrados = [
        { value: "", label: "Seleccione un grado" }, // Opción vacía
        ...grados.map(grado => ({
            value: grado.grado_id,
            label: grado.nombre_grado
        }))
    ];




    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Asignación</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Usuario:</label>
                        <Select
                            name="usuario_id"
                            value={opcionesUsuarios.find(option => option.value === formData.usuario_id)}
                            onChange={(selectedOption) => handleChange({
                                target: {name: 'usuario_id', value: selectedOption.value}
                            })}
                            options={opcionesUsuarios}
                            required
                        />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Grado:</label>
                        <Select
                            name="grado_id"
                            value={opcionesGrados.find(option => option.value === formData.grado_id)}
                            onChange={(selectedOption) => handleChange({
                                target: {name: 'grado_id', value: selectedOption.value}
                            })}
                            options={opcionesGrados}
                            required
                        />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Ciclo:</label>
                        <input
                            type="number"
                            id="ciclo"
                            name="ciclo"
                            className="form-control"
                            value={formData.ciclo}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>
    );
};

export default AlumnoForm;